import PropTypes from 'prop-types';
// material
import { Card, Box } from '@mui/material';
//
import { Map, GeofenceMap, PositionsAnalyse, Add3DElement } from '../../map';
// ----------------------------------------------------------------------

ReportClubMap.propTypes = {
  summary: PropTypes.array
};

export default function ReportClubMap({ summary }) {
  return (
    <Card>
      <Box sx={{ height: 600 }} dir="ltr">
        <Map>
          <GeofenceMap />
          <Add3DElement />
          <PositionsAnalyse summary={summary} />
        </Map>
      </Box>
    </Card>
  );
}
